import { useEffect } from "react";
import "./AtivarEmail.css";

export default function AtivarEmail({ open, titulo, onClose, onConfirmar, onConfirm }) {
  if (!open) return null;

  const submit = onConfirmar || onConfirm || (() => {});

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  const onKeyDown = (e) => {
    if (e.key === "Escape") onClose?.();
    if (e.key === "Enter") submit();
  };

  return (
    <div className="emact-bg" onKeyDown={onKeyDown} tabIndex={-1}>
      <div className="emact-box" role="dialog" aria-modal="true" aria-label="Ativar e-mail">
        <header className="emact-head">
          <h3 className="emact-title">Ativar e-mail</h3>
          <button className="emact-x" type="button" onClick={onClose} aria-label="Fechar">
            x
          </button>
        </header>

        <div className="emact-body">
          Deseja <strong>ativar</strong> "{titulo || "este e-mail"}"?
        </div>

        <footer className="emact-foot">
          <button className="emact-btn emact-btn-ghost" type="button" onClick={onClose}>
            Cancelar
          </button>
          <button className="emact-btn emact-btn-ok" type="button" onClick={submit}>
            Ativar
          </button>
        </footer>
      </div>
    </div>
  );
}
